import { useAxios } from 'shared/hooks/useAxios';
import { IPetResponsePayloads, IPetServiceProps } from 'shared/interfaces/IPets';
import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
const { GET } = useAxios();

export const petDao = () => {
  const getAnimal = async (data?: IPetServiceProps['animalProps']) => {
    const response = await GET<IPetResponsePayloads['animalResponsePayload']>({
      url: `${ENDPOINTS.PETS_ANIMAL}`,
    });
    return response.data;
  };

  const getBreed = async (data: IPetServiceProps['breedProps']) => {
    const response = await GET<IPetResponsePayloads['breedResponsePayload']>({
      url: `${ENDPOINTS.PETS_BREED}/${data?.animal}`,
    });
    return response.data;
  };
  const getSize = async (data: IPetServiceProps['sizeProps']) => {
    const response = await GET<IPetResponsePayloads['sizeResponsePayload']>({
      url: `${ENDPOINTS.PETS_SIZE}/${data?.animal}/${data?.breed}`,
    });
    return response.data;
  };

  return {
    getAnimal,
    getBreed,
    getSize,
  };
};
